/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_Error_FrozenInputs */

const fr_membership_friend_guest_error_frozen = /** @type {(inputs: Membership_Friend_Guest_Error_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement est en pause ce jour-là.`)
};

/**

* @param {Membership_Friend_Guest_Error_FrozenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_error_frozen = /** @type {((inputs?: Membership_Friend_Guest_Error_FrozenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_Error_FrozenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_error_frozen(inputs)
});